import { FC } from 'react';

// https://dev.to/
const Podcasts: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="24" height="24">
      <g>
        <path
          fill="#292F33"
          d="M10 19h24v2H10zm15 15c0 2.208-.792 4-3 4-2.209 0-3-1.792-3-4s.791-2 3-2c2.208 0 3-.208 3 2z"
        ></path>
        <path fill="#66757F" d="M22 35c-6.627 0-10 1.343-10 3v2h20v-2c0-1.657-3.373-3-10-3z"></path>
        <path fill="#99AAB5" d="M22 4a9 9 0 00-9 9v7h18v-7a9 9 0 00-9-9z"></path>
        <g fill="#292F33" transform="translate(4 4)">
          <circle cx="15.5" cy="2.5" r="1.5"></circle>
          <circle cx="20.5" cy="2.5" r="1.5"></circle>
          <circle cx="17.5" cy="6.5" r="1.5"></circle>
          <circle cx="22.5" cy="6.5" r="1.5"></circle>
          <circle cx="12.5" cy="6.5" r="1.5"></circle>
          <circle cx="15.5" cy="10.5" r="1.5"></circle>
          <circle cx="10.5" cy="10.5" r="1.5"></circle>
          <circle cx="20.5" cy="10.5" r="1.5"></circle>
          <circle cx="25.5" cy="10.5" r="1.5"></circle>
          <circle cx="17.5" cy="14.5" r="1.5"></circle>
          <circle cx="22.5" cy="14.5" r="1.5"></circle>
          <circle cx="12.5" cy="14.5" r="1.5"></circle>
        </g>
        <path fill="#66757F" d="M13 19.062V21c0 4.971 4.029 9 9 9s9-4.029 9-9v-1.938H13z"></path>
        <path
          fill="#66757F"
          d="M34 18a1 1 0 00-1 1v2c0 6.074-4.925 11-11 11s-11-4.926-11-11v-2a1 1 0 00-2 0v2c0 7.18 5.82 13 13 13s13-5.82 13-13v-2a1 1 0 00-1-1z"
        ></path>
      </g>
    </svg>
  );
};

export default Podcasts;
